import {useEffect} from 'react';
import {useKioskoScannerControls} from 'context/kiosko/hooks';
import {KioskoScanData} from 'context/kiosko';

type Props = {
  onDocumentScanned: (data: KioskoScanData | null) => void;
};
function useScanDocumentKiosko({onDocumentScanned}: Props) {
  const {scanDocument, lastScanResult, success, resetScannerState} =
    useKioskoScannerControls();

  useEffect(
    function onDocumentScannedEffect() {
      if (Boolean(lastScanResult) && success) {
        onDocumentScanned(lastScanResult);
        resetScannerState();
      }
    },
    [lastScanResult, onDocumentScanned, resetScannerState, success],
  );

  return {
    scanDocument,
  };
}

export {useScanDocumentKiosko};
